module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Bold-9001a0ceb728fa8ce087075e5e965f46.otf";